import React, { useState } from "react";
import './index.css';

export default class CreateDesign extends React.Component {

    static defaultProps = {
        auth: [],
        showNameBox: true
    };

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            auth: props.auth,
            showNameBox: props.showNameBox
        };
        this.designAuthRef = React.createRef();
    }

    componentDidMount() {
        this.getContext();
        this._getDesignList();
    }

    _getDesignList = () =>{
        const _this = this;
        const { auth } = this.state;
        let opt = {
            renderEl: this.designAuthRef.current,
            value: auth,
            jobTitleEnable: !0,
            deptChildEnable: !0,
            hasDock: false,
            canClick: true,
            msg: React.language("member.add"),
            managerPermissionEnable: !0,
            publicPermissionEnable: !0,
            onStopEdit: function (a) {
                _this.setState({auth: a})
            }
        }
        new window.FX.MemberSelectPane(opt)
    }

    getContext = () =>{
        this.props.getContext && this.props.getContext(this)
    }

    changeName = (e) =>{
        const name = e.target.value;
        this.setState({name});
    }
    
    render() {
        const { name, showNameBox } = this.state;
        return (
            <div className="createDesign">
                <div className="createDesignContent">
                    {showNameBox && <div className="designName">
                        <input type="text" placeholder={React.language("create.dashboard.design.tip")} maxLength={26} value={name} onChange={this.changeName} />
                    </div>}
                    <div className="designAuth">
                        <div className="designAuthTitle">
                            <span className="auth-title">{React.language("set.dashboard.design.auth")}</span>
                            <span className="auth-tip">{React.language("set.dashboard.design.auth.msg")}</span>
                        </div>
                        <div className="designAuthCont">
                            <div className="auth-item">
                                <div className="item-desc">
                                    <div className="desc-title">
                                        <span>{React.language("dashboard.design.auth.title")}</span>
                                    </div>
                                    <div className="desc-msg">
                                        <span>{React.language("dashboard.design.auth.msg")}</span>
                                    </div>
                                </div>
                                <div className='userAuthCont' ref={this.designAuthRef}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


